import { createRoutine } from 'redux-saga-routines';

export const fetchVendorObjectProperties = createRoutine(
  'FETCH_VENDOR_OBJ_PROPERTIES'
);
export const fetchVendorTicketFieldMappings = createRoutine(
  'FETCH_VENDOR_TICKET_FIELD_MAPPINGS'
);
export const fetchVendorEntityFieldMappings = createRoutine(
  'FETCH_VENDOR_ENTITY_FIELD_MAPPINGS'
);
export const fetchVendorDeduplicationMappings = createRoutine(
  'FETCH_VENDOR_DEDUPLICATION_MAPPINGS'
);

export const createTicketFieldMapping = createRoutine(
  'CREATE_TICKET_FIELD_MAPPING'
);
export const changeTicketFieldMapping = createRoutine(
  'CHANGE_TICKET_FIELD_MAPPING'
);
export const changeDeduplicationMapping = createRoutine(
  'CHANGE_SUPPORT_DEDUPLICATION_MAPPING'
);

export const createDeduplicationMapping = createRoutine(
  'CREATE_SUPPORT_DEDUPLICATION_MAPPING'
);

export const fetchDeduplicationMapping = createRoutine(
  'FETCH_SUPPORT_DEDUPLICATION_MAPPING'
);
export const fetchTicketFieldMapping = createRoutine(
  'FETCH_TICKET_FIELD_MAPPING'
);
export const removeTicketFieldMapping = createRoutine(
  'DEL_TICKET_FIELD_MAPPING'
);
export const clearTicketFieldMapping = createRoutine(
  'CLEAR_TICKET_FIELD_MAPPING'
);
export const cancelDeduplicationMapping = createRoutine(
  'CANCEL_SUPPORT_DEDUPLICATION_MAPPING'
);
export const cancelTicketFieldMapping = createRoutine(
  'CANCEL_TICKET_FIELD_MAPPING'
);
export const changeConfigTab = createRoutine('CHANGE_CONFIG_TAB');
export const fetchContactSyncStatus = createRoutine(
  'FETCH_CONTACT_SYNC_STATUS'
);
export const saveContactSyncStatus = createRoutine('SAVE_CONTACT_SYNC_STATUS');
export const changeContactSyncStatus = createRoutine(
  'CHANGE_CONTACT_SYNC_STATUS'
);
export const fetchIntegrationContextStatus = createRoutine(
  'FETCH_CONTEXT_STATUS'
);
export const saveIngrationContextStatus = createRoutine('SAVE_CONTEXT_STATUS');
export const cancelIntegrationContextStatus = createRoutine(
  'CANCEL_CONTEXT_STATUS'
);
